export const overviewType = {
	_id: '',
	total_device: '',
	device_with_issue: '',
	out_of_order_vehicle: '',
	total_vehicle: '',
};
export const IDateRangeFilter = {
	startDate: '',
	endDate: '',
	startTime: '',
	endTime: '',
};

export const initialValues = {
	deviceVehicleStatus: overviewType,
	fuelEfficiency: [],
	vehicleUsage: [],
	overviewVehicleAlerts: [{ name: 'Vehicle Alerts', data: [] }],
	metricsPerPeriod: {},
	totalOpenAlerts: { _id: '', open_alert_count: '', Total_Alerts: '' },
	drainage: [{ name: 'Total Drainage (L)', data: [] }],
	totalDrainage: [{ name: 'Total Drainage Count(L)', data: [] }],
	totalFuel: [{ name: 'Total Fuel Consumed', data: [] }],
	totalFilling: [{ name: 'Total Fillings count', data: [] }],
	avgFuel: [{ name: 'Average Fuel Level', data: [] }],
	temperature: [{ name: 'Temperature Data', data: [] }],
	totalRefuel: [{ name: 'Total Refuel', data: [] }],
	ecoDriverTotalScore: [{ name: 'Eco Driver Average Score', data: [] }],
	mileageDriven: [{ name: 'Mileage Driven (km)', data: [] }],
	nbTrips: [{ name: 'No Of Trips', data: [] }],
	totalIdlingTime: [{ name: 'Total Idling Time (Min)', data: [] }],
	avgIdlingTime: [{ name: 'Average Idling Time (Min)', data: [] }],
	fuelAvgEfficiency: [{ name: 'Fuel Average Efficiency', data: [] }],
	fuelAvgConsumption: [{ name: 'Average Consumption (L)', data: [] }],
	vehicleUtilization: [{ name: 'Vehicle Utilization', data: [] }],
	dateRangeFilterFromStore: {
		startDate: '',
		endDate: '',
		startTime: '',
		endTime: '',
	},
	dateRangeFilterFromStorePrev: {
		startDate: '',
		endDate: '',
		startTime: '',
		endTime: '',
	},
	maintenanceStatus: [
		{
			name: 'Maintenance Status',
			data: [
				{
					series: [] as any,
					labels: [] as any,
				},
			],
		},
	],
	driverPerformance: [
		{
			name: 'Driver Performance',
			data: [
				{
					series: [] as any,
					labels: [] as any,
				},
			],
		},
	],
	routeOptimization: [{ name: 'Route Optimization', data: [] }],
	environmentalImpact: [{ name: 'Environmental Impact', data: [] }],
	downtimeAnalysis: [{ name: 'Downtime Analysis', data: [] }],
	tcoAdmangCost: [{ name: 'Administrative Management Cost', data: [] }],
	fpOverviewTcoOperationalCost: [{ name: 'Operational Cost', data: [] }],
	fpOverviewTcoInsuranceCost: [{ name: 'Insurance Cost', data: [] }],
	fpOverviewTcoMaintenanceCost: [{ name: 'Maintenance Cost', data: [] }],
	fpOverviewTcoVehAcquisitionCost: [{ name: 'Vehicle Acquisition Cost', data: [] }],
	fpOverviewTcoFuelCost: [{ name: 'Fuel Cost', data: [] }],
	fpOverviewTcoFuelConsumed: [{ name: 'Fuel Consumed', data: [] }],
	fpOverviewTcoVehicleLeasingCost: [{ name: 'Vehicle Leasing Cost', data: [] }],
	fpOverviewDashcamDeviceStatus: [] as any[],
	fpOverviewDashcamDeviceTypes: [] as any[],
	fpOverviewDashcamAlertTypes: [] as any[],
	fpOverviewDashcamAlertSeverity: [] as any[],
	fleetHealth: [] as IFleetHealth[],
	fleetUsage: [] as IFleetUsage[],
	temperatureData: [] as ITemperatureData[],
	activeVehicles: {} as any,
	activeAlertsCount: {} as any,
	avgFuelEfficiencyCount: {} as any,
	fleetUtilizationPercent: {} as any,
	distanceCovered: null as { total_trips: number; total_distance_km: number } | null,
	// ── Section 1 V2 APIs 
	tripDistanceKm: null as { data: { x: string; y: number }[]; name: string } | null,
	fleetUtilizationRate: null as {
		name?: string;
		utilisation_percent?: string | number;
		active_vehicles?: number;
		avg_engine_on_per_active_vehicle?: string;
		total_vehicles?: number; // optional - only if backend returns it
	} | null,
	vehicleTypeUtilization: [] as { pct: number; vehicle_type: string }[],
	idleTimeMin: null as { total_idle: number; avg_idle_per_vehicle: number; chart: { data: { x: string; y: number }[] } } | null,
	stopDuration: null as {
		total_stop_duration_hrs: number;
		avg_stop_per_vin_hrs: number;
		chart: { x: string; y: number }[];
		name: string;
	} | null,
	noOfTrips: null as { total_trips: number; avg_per_day: number; chart: { data: { x: string; y: number }[] } } | null,
	vehicleAlertsV2: [] as { count: number; _id: string }[],
	// ── Section 2 V2 APIs 
	distanceDrivenKm: null as { data: { x: string; y: number }[]; name: string } | null,
	fuelEnergyTiles: null as { idle_fuel_waste_L: number; actual_consumption_L: number; avg_efficiency_L_100km: number } | null,
	fuelConsumptionChart: null as { data: [string, number][]; name: string } | null,
	idleFuelWasteChart: null as { data: [string, number][]; name: string } | null,
	driverScores: [] as { driver_name: string; score: number; vin: string }[],
	ecoDriverScore: null as { idle_avoidance: number; harsh_accel: number; harsh_braking: number; speed_mgmt: number; fleet_avg_eco_score: number } | null, drivingHours: [] as { name: string; data: [string, number][] }[],
	driveVsIdle: [] as { name: string; data: { date: string; idle_pct: number; drive_pct: number }[] }[],
	driveVsIdleAllDrivers: [] as { name: string; data: { date: string; idle_pct: number; drive_pct: number }[] }[],
	driverNameFilter: [] as { _id: string }[],
	// ── Section 4 V2 APIs 
	dashcamAlertEvents: [] as { x: string; series: { count: number; category: string }[] }[],
	obdAlertEvents: [] as { x: string; series: { count: number; category: string }[] }[],
	dashcamAlertSeverity: [] as { severity: string; alert_count: number }[],
	// ── Section 5 V2 APIs 
	maintenanceStatusV2: null as {
		good_count: number;
		due_soon_count: number;
		overdue_count: number;
		total_vehicles: number;
		most_overdue_vin: string;
		most_overdue_days: number;
		next_service_vin: string;
		next_service_date: string;
		name: string;
	} | null,
	maintServiceOverdue: null as { data: [string, number][]; name: string; due_threshold: number } | null,
};
export interface ITotalAlerts {
	total_alerts: string;
}
export interface IDeviceVehicleStatus {
	_id: string;
	total_device: string;
	device_with_issue: string;
	out_of_order_vehicle: string;
	total_vehicle: string;
}
export interface IFuelEfficiency {
	_id: string;
	efficiency: string;
}
export interface IFleetHealth {
	_id: string;
	health: string;
}
export interface IFleetUsage {
	_id: string;
	health: string;
}
export interface ITemperatureData {
	_id: string;
	health: string;
}
export interface IOverviewVehicleAlerts {
	_id: string;
	count: string;
}
export interface IOverviewVehicleUsage {
	_id: string;
	mileage: string;
}
export interface IStatistics {
	header: string;
	data: IDataStatistics[];
}
export interface IDataStatistics {
	name: string;
	value: string;
}